export default {
  data() {
    return {
      Type: "",//View Create Edit
      DialogVisible: false,
      DialogFormData: {},
      DialogReady: true,

      _InitData: {}//用于组件内部初始化数据
    }
  },
  created() {
    for (const key in this.$data) {
      if (key != "_InitData") {
        //_和$开头的属性不会被vue代理（因可能和内部属性冲突），需要使用this.$data.XXX或this._data.XXX调用
        this.$data._InitData[key] = this._.cloneDeep(this[key]);
      }
    }
  },
  methods: {
    Show: async function (item) {
      if (item) {
        var obj = {};
        for (var attr in this.DialogFormData) {
          if (attr in item) { obj[attr] = item[attr] }
          else { obj[attr] = this.DialogFormData[attr] }
        }
        this.DialogFormData = this._.cloneDeep(obj);
      }
      try {
        this.BeforeShow && await this.BeforeShow(item);//调接口更新formdata
        this.DialogVisible = true;//resourcelist初始化 initfile
        this.$nextTick(() => {
          this.AfterShow && this.AfterShow(item);
        })
      } catch (error) {//await BeforeShow 的 reject回调
      }

    },
    Hide() {
      this.BeforeHide && this.BeforeHide();
      for (const key in this.$data) {
        if (key != "_InitData") {
          this[key] = this._.cloneDeep(this.$data._InitData[key]);
        }
      }
    }
  }
};
